import { getMessageList } from '../services';

export default {
  namespace: 'warningMessage',
  state: {
    messageList: [],
    pagination: {
      current: 1,
      pageSize: 10,
      total: 0, 
    },
  },
  effects: {
    * getMessageList ({ payload }, { call, put }) {
      const res = yield call(getMessageList, payload);
      const { data, pageNum, pageSize, total } = res;
      yield put({
        type: 'update',
        payload: {
          messageList: data || [], 
          pagination: {
            current: pageNum,
            pageSize,
            total, 
          },
        },
      });
      return res;
    },
  },
  reducers: {
    update (state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
